import axios from "axios";

export async function GetUsernameByEmail(data) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_AWS_URL}/auth/get-username-by-email`,
      data,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status === 400) {
        return {
          status: 400,
          message: "Nome de usuário nao fornecido.",
        };
      }
      return {
        status: 500,
        message: "Erro ao buscar usuário.",
      };
    }
  }
}
